import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _FilesList;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { IconButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Spinner } from '@instructure/ui-spinner';
import { IconDocumentLine, IconTrashLine } from '@instructure/ui-icons';
import { SimpleModal, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import isImageString from '../isImage';
import t from '@instructure/quiz-i18n/format-message';
var SPACE_KEY = 0x20;
var ENTER_KEY = 0x0d;
var FilesList = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_FilesList = /*#__PURE__*/function (_Component) {
  function FilesList() {
    var _this2;
    _classCallCheck(this, FilesList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, FilesList, [].concat(args));
    _defineProperty(_this2, "state", {
      isModalOpen: false,
      modalContent: {
        name: 'empty',
        url: ''
      }
    });
    _defineProperty(_this2, "handleCloseModal", function () {
      _this2.setState({
        isModalOpen: false
      });
    });
    _defineProperty(_this2, "handleOpenModal", function (modalContent) {
      _this2.setState({
        isModalOpen: true,
        modalContent: modalContent
      });
    });
    _defineProperty(_this2, "handleOpenUrl", function (url) {
      window.open(url, '_blank');
    });
    _defineProperty(_this2, "renderImagePreview", function (url, name) {
      return jsx("div", {
        css: _this2.props.styles.previewContainer
      }, jsx("img", {
        src: url,
        alt: name,
        css: _this2.props.styles.previewImg
      }));
    });
    _defineProperty(_this2, "renderFilePreview", function () {
      return jsx("div", {
        css: _this2.props.styles.previewContainer
      }, jsx(IconDocumentLine, {
        size: "medium"
      }));
    });
    _defineProperty(_this2, "renderPreview", function (file) {
      var url = file.url,
        size = file.size,
        name = file.name,
        isUploading = file.isUploading;
      if (!url && !isUploading) {
        return jsx("div", {
          css: _this2.props.styles.userResponse
        }, jsx(Text, {
          color: "primary"
        }, t('(no answer)')));
      }
      var isImage = isImageString(name);
      var onClick = isImage ? function () {
        return _this2.handleOpenModal(file);
      } : function () {
        return _this2.handleOpenUrl(url);
      };
      var containerProps = _this2.props.readOnly ? {} : {
        tabIndex: '0',
        role: 'button'
      };
      return jsx("div", {
        css: _this2.props.styles.fileLinkWrapper
      }, jsx("div", Object.assign({}, containerProps, {
        "data-testid": "button-container",
        onClick: onClick,
        css: _this2.props.styles.fileLink,
        onKeyPress: _this2.makeKeyPressHandler(onClick)
      }), jsx("div", {
        css: _this2.props.styles.userResponse
      }, isImage ? _this2.renderImagePreview(url, name) : _this2.renderFilePreview(), jsx("div", {
        css: _this2.props.styles.nameContainer
      }, jsx("div", null, jsx(Text, {
        color: "brand"
      }, name)), jsx("div", null, jsx(Text, {
        color: "primary"
      }, t('{size, number}Kb', {
        size: Math.round(size * 0.001),
        description: 'size of file in kilobytes'
      }))), !isUploading ? null : jsx(Spinner, {
        themeOverride: _this2.props.styles.spinner,
        renderTitle: t('Loading'),
        size: "small"
      })))), _this2.props.makeRemoveHandler && jsx("div", {
        css: _this2.props.styles.removeButton,
        "data-role": "removeButton"
      }, jsx(IconButton, {
        onClick: _this2.props.makeRemoveHandler(file),
        name: "Close",
        size: "small",
        renderIcon: IconTrashLine,
        withBackground: false,
        withBorder: false,
        readOnly: _this2.props.readOnly,
        screenReaderLabel: t('Remove File Named {name}', {
          name: name
        })
      })));
    });
    _defineProperty(_this2, "renderPreviews", function () {
      var _this2$props = _this2.props,
        files = _this2$props.files,
        showIfEmpty = _this2$props.showIfEmpty;
      if (typeof files === 'undefined') {
        return jsx("div", {
          css: _this2.props.styles.entryWrapper
        }, jsx(Text, {
          color: "primary"
        }, t('(response not displayed)')));
      }
      if (showIfEmpty && (!files || files.length === 0)) {
        return jsx("div", {
          css: _this2.props.styles.entryWrapper
        }, jsx(Text, {
          color: "primary"
        }, t('(no answer)')));
      }
      return files.map(function (file) {
        return jsx("div", {
          css: _this2.props.styles.entryWrapper,
          key: file.id
        }, _this2.renderPreview(file));
      });
    });
    return _this2;
  }
  _inherits(FilesList, _Component);
  return _createClass(FilesList, [{
    key: "makeKeyPressHandler",
    value: function makeKeyPressHandler(callback) {
      return function (event) {
        if (event.charCode === SPACE_KEY || event.charCode === ENTER_KEY) {
          event.preventDefault();
          callback();
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        modalContent = _this$state.modalContent,
        isModalOpen = _this$state.isModalOpen;
      return jsx("div", null, jsx("div", {
        className: "fs-mask"
      }, this.renderPreviews()), jsx(SimpleModal, {
        isModalOpen: isModalOpen,
        title: modalContent.name,
        label: modalContent.name,
        onModalDismiss: this.handleCloseModal
      }, jsx("img", {
        css: this.props.styles.modalImage,
        className: "fs-mask",
        src: modalContent.url,
        alt: modalContent.name
      })));
    }
  }]);
}(Component), _defineProperty(_FilesList, "displayName", 'FilesList'), _defineProperty(_FilesList, "componentId", "Quizzes".concat(_FilesList.displayName)), _defineProperty(_FilesList, "propTypes", {
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    size: PropTypes.number.isRequired,
    isUploading: PropTypes.bool
  })),
  makeRemoveHandler: PropTypes.func,
  showIfEmpty: PropTypes.bool,
  readOnly: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_FilesList, "defaultProps", {
  files: void 0,
  makeRemoveHandler: void 0,
  showIfEmpty: false,
  readOnly: false
}), _FilesList)) || _class);
export { FilesList as default };